export const SmsPackageOptions = [
  { value: 2500, label: '2,500 sms/mo' },
  { value: 5000, label: '5,000 sms/mo' },
  { value: 7500, label: '7,500 sms/mo' },
];

export const SmsPackageOptionsDefault = 2500;
